module.exports = __webpack_public_path__ + "static/img/1.3f79b49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/1.png
// module id = pkSn
// module chunks = 0